import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import Body from './Body';
import Header from './Header';

const Container = styled.div`
  ${tw`flex-col mb-def md:mb-abs4`};
  color: ${(props) => (props.white ? 'white' : 'inherit')};

  ${({ customStyle }) => customStyle}
`;

class Accordion extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      detailed: this.props.open,
    };
  }

  componentDidUpdate(prevProps) {
    // React to `open` props passed to the composant.
    // If the new `open` props is true, use it internally instead of the `detailed` state.
    if (!prevProps.open && prevProps.open !== this.props.open) {
      this.setState({
        detailed: this.props.open,
      });
    }
  }

  toggle = () =>
    this.setState((prevState) => ({
      detailed: !prevState.detailed,
    }));

  render() {
    return (
      <Container customStyle={this.props.customStyle} white={this.props.white}>
        {this.props.header && (
          <Header
            detailed={this.state.detailed}
            header={this.props.header}
            id={this.props.id}
            toggle={this.toggle}
            white={this.props.white}
          />
        )}
        <Body show={this.state.detailed}>{this.props.content}</Body>
      </Container>
    );
  }
}

Accordion.propTypes = {
  content: PropTypes.node.isRequired,
  customStyle: PropTypes.arrayOf(PropTypes.string),
  header: PropTypes.node,
  id: PropTypes.string,
  open: PropTypes.bool,
  white: PropTypes.bool,
};

export default Accordion;
